<script>
import { mapState } from "vuex";

import { validateAndSubmit } from '../../../mixins/validateAndSubmit';
import { validationClass } from '../../../mixins/validationClass';

export default {
  data() {
    return {
        disableOnSubmit : false,
        reasons: false,
        form: {
            reason: '',
        }
    };
  },

  props: ["url"],

    mixins: [validateAndSubmit, validationClass],

  computed: {},

  created() {},

  mounted() {},

  watch: {},

  methods: {
    toggleCancelModal() {
      $("#cancelSubscriptionModal").modal("show");
    },

    showReasons() {
      this.reasons = true;
    },

    cancelSubscription() {
      axios
        .post(this.url)
        .then((response) => {
          $("#cancelSubscriptionModal").modal("hide");
          if (response.data.error) {
            this.$root.$refs.toastr.e(response.data.message);
          } else {
            this.$root.$refs.toastr.s(response.data.message);

            setTimeout(function () {
              location.reload();
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$root.$refs.toastr.e("ERROR");
        });
    },
  },
};
</script>
